import { Tab } from "@headlessui/react";
import React, { Fragment, useState, FC } from "react";
import { Dialog, Transition } from "@headlessui/react";
import VoyageCard from "components/VoyageCard/VoyageCard";
import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { compteService } from "_services/compte.service";
import { VoyageDataType } from "data/types";
import 'react-tooltip/dist/react-tooltip.css';
import AppContext from 'AppContext';
import ButtonCircleSmall from "shared/Button/ButtonCircleSmall";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { XMarkIcon, CheckIcon } from "@heroicons/react/24/solid";
import { voyageService } from '_services/voyage.service';
import { useTranslation } from 'react-i18next';

export interface MesVoyagesProps {
  className?: string;
}

const MesVoyages: FC<MesVoyagesProps> = ({ className = "" }) => {
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const langue = currentLanguage === 'en' ? 'EN' : 'FR';

  const isAfterNov20 = new Date() > new Date("2024-11-20");
  const isBeforeDec5 = new Date() < new Date("2024-12-05");

  const { setVoyageInfo, setAfficheMenuMobile } = useContext(AppContext);
  const [voyageurData, setVoyageurData] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [valeurReponse1, setValeurReponse1] = useState<boolean>(false);  
  const [valeurReponse2, setValeurReponse2] = useState<boolean>(false);
  const [valeurPrix0, setValeurPrix0] = useState<boolean>(false);  
  const [valeurPrix1, setValeurPrix1] = useState<boolean>(false);  
  const [valeurPrix2, setValeurPrix2] = useState<boolean>(false);  
  const [valeurPrix3, setValeurPrix3] = useState<boolean>(false);  
  const [valeurPrix4, setValeurPrix4] = useState<boolean>(false);  
  const [valeurPrix5, setValeurPrix5] = useState<boolean>(false);  
  const [affichagePrix, setAffichagePrix] = useState<boolean>(false);
  const [affichageValider, setAffichageValider] = useState<boolean>(false);
  const [affichageSondage, setAffichageSondage] = useState<boolean>(true);
  const navigate = useNavigate();

  useEffect(() => {
    setVoyageInfo(null);
    setAfficheMenuMobile(true);
    // Appeler l'API pour obtenir les voyages
    compteService.getVoyages()
      .then((response) => {
        setVoyageurData(response.data);
   
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données:", error);
        navigate('/');
      });
  }, []);

  
    const handleRadioChange = (nom: String) => {


      if(nom === "reponse1")
      {
        setValeurReponse1(true);
        setValeurReponse2(false);
        setAffichagePrix(true);
        setAffichageValider(false);
      }
      else if(nom === "reponse2")
      {
        setValeurReponse1(false);
        setValeurReponse2(true);
        setAffichagePrix(false);
        setAffichageValider(true);
        setValeurPrix0(false);
        setValeurPrix1(false);
        setValeurPrix2(false);
        setValeurPrix3(false);
        setValeurPrix4(false);
        setValeurPrix5(false);
      }
      else
      {
          if(nom === "prix0")
          {
            setValeurPrix0(true);
            setValeurPrix1(false);
            setValeurPrix2(false);
            setValeurPrix3(false);
            setValeurPrix4(false);
            setValeurPrix5(false);
          }
          else if(nom === "prix1")
          {
              setValeurPrix1(true);
              setValeurPrix0(false);
              setValeurPrix2(false);
              setValeurPrix3(false);
              setValeurPrix4(false);
              setValeurPrix5(false);
          }
          else if(nom === "prix2")
            {
                setValeurPrix2(true);
                setValeurPrix0(false);
                setValeurPrix1(false);
                setValeurPrix3(false);
                setValeurPrix4(false);
                setValeurPrix5(false);
            }
            else if(nom === "prix3")
              {
                  setValeurPrix3(true);
                  setValeurPrix0(false);
                  setValeurPrix2(false);
                  setValeurPrix1(false);
                  setValeurPrix4(false);
                  setValeurPrix5(false);
              }
              else if(nom === "prix4")
                {
                    setValeurPrix4(true);
                    setValeurPrix0(false);
                    setValeurPrix2(false);
                    setValeurPrix3(false);
                    setValeurPrix1(false);
                    setValeurPrix5(false);
                }
                else if(nom === "prix5")
                  {
                      setValeurPrix5(true);
                      setValeurPrix0(false);
                      setValeurPrix2(false);
                      setValeurPrix3(false);
                      setValeurPrix4(false);
                      setValeurPrix1(false);
                  }

          setAffichageValider(true);
      }

    };


    const handleSubmit = async () => {
        // Appel de l'API pour mettre à jour le profil
      compteService.updateSondage({ 
        idSondage:voyageurData.idSondage,
        "reponse1":valeurReponse1,
        "reponse2":valeurReponse2,
        "reponse3":valeurPrix0,
        "reponse4":valeurPrix1,
        "reponse5":valeurPrix2,
        "reponse6":valeurPrix3,
        "reponse7":valeurPrix4,
        "reponse8":valeurPrix5
        })
        .then((response) => {
          setAffichageSondage(false);
          alert("Merci pour votre participation au sondage !");
        })
        .catch((error: any) => {
          if (error.response?.status === 401) {
            alert("Erreur : votre réponse n'a pas pu être enregistrée car vous n'êtes plus connecté(e)");
            navigate('/login');
          }
          else
          {
            alert("Erreur : votre réponse n'a pas pu être enregistrée");
            navigate('/login');
          }
        })
        }

  const handleAccepterCoCreateur = (idVoyage: number, index: number) => {

    if(voyageurData.username !== null && voyageurData.username !== '')
    {
      setIsLoading(true);
      voyageService.accepterCoCreateurVoyage(idVoyage)
        .then((response: any) => {

          setIsLoading(false); // Arrêter le chargement

          alert(t('alertAccepterCoCreateur'));

          window.location.reload();
          

        })
        .catch((error: any) => {
          setIsLoading(false); // Arrêter le chargement
          if (error.response?.status === 401) {
            alert("Erreur lors de l'acceptation, vous devez être connecté.");
            navigate("/login");
          } else if (error.response?.status === 406 && error.response.data.message !== undefined) {
            console.log(error.response);
            alert(error.response.data.message);
          }
          else {
            alert("Erreur lors de l'acceptation.");
          }
          console.log('acceptation KO', error);
        });
      }
      else
      {
        alert("Vous devez saisir un nom d'utilisateur sur votre profil dans \"Mon compte\" pour devenir co-créateur d'un voyage !")
      }
  }

  const handleRefuserCoCreateur = (idVoyage: number, index: number) => {

    if(voyageurData.username !== null && voyageurData.username !== '')
    {
    if(window.confirm(
      t('alertRefuserCoCreateur')
    ))
    {
      setIsLoading(true);
      voyageService.refuserCoCreateurVoyage(idVoyage)
        .then((response: any) => {
          // Créez une nouvelle liste de demandes en excluant l'élément à l'index
          const nouvellesDemandes = voyageurData.mesDemandes.filter((_: any, i: any) => i !== index);

          // Mettez à jour l'état avec la nouvelle liste de demandes
          setVoyageurData((prevState: any) => ({
            ...prevState,
            mesDemandes: nouvellesDemandes,
          }));

          
          setIsLoading(false); // Arrêter le chargement

        })
        .catch((error: any) => {
          setIsLoading(false); // Arrêter le chargement
          if (error.response?.status === 401) {
            alert("Erreur lors du refus, vous devez être connecté.");
            navigate("/login");
          } else if (error.response?.status === 406 && error.response.data.message !== undefined) {
            console.log(error.response);
            alert(error.response.data.message);
          }
          else {
            alert(t('planner.refuseError'));
          }
          console.log('refus KO', error);
        });
    }
  }
  else
  {
    alert(t('planner.usernameRequiredToRefuse'))
  }
  }

  const renderSection1 = () => {
    return (
      <div className="listingSection__wrap [ nc-box-has-hover ] [ nc-dark-box-bg-has-hover ]">
        <div>
          <h2 className="text-2xl font-semibold dark:text-white">{t('voyagesCrees')}</h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <Tab.Group>
            <Tab.Panels>
              <Tab.Panel className="">
                <div className="mt-2 grid grid-cols-1 gap-6 md:gap-7 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                  {voyageurData && voyageurData.mesVoyages && voyageurData.mesVoyages.length > 0 ? (
                    voyageurData.mesVoyages.map((voyage: VoyageDataType) => (
                      <VoyageCard key={voyage.id_voyage} voyageData={voyage} voyageKey={voyage.id_voyage} 
                      isCreateur={voyage.createur === "X" ? true : false}
                      isCoCreateur={voyage.createur !== "X" ? true : false}
                      voyageurUsername={voyageurData.username}
                      />
                    ))
                  ) : null }
                  <span className="block text-neutral-500 dark:text-white">
                    {voyageurData && voyageurData.mesVoyages && voyageurData.mesVoyages.length === 0
                    ? t('aucunVoyageCree')
                    : "" }
                  </span>
                </div>
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
    );
  };

  const renderSectionCoCreateur= () => {
    return (
      <div className="listingSection__wrap [ nc-box-has-hover ] [ nc-dark-box-bg-has-hover ]">
        <div>
          <h2 className="text-2xl font-semibold">{t('mesDemandes')}</h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <Tab.Group>
            <Tab.Panels>
              <Tab.Panel className="">
                <div className="mt-2">
                  {voyageurData && voyageurData.mesDemandes && voyageurData.mesDemandes.length > 0 ? (
                    voyageurData.mesDemandes.map((demande: any, index: number) => (
                     <div className="mb-2">{t('planner.coCreatorRequestBefore')} {demande.username} {t('planner.coCreatorRequestAfter')} {demande.id_voyage} {demande.titre_voyage} ?  <ButtonCircleSmall className="couleurVert" onClick={() => handleAccepterCoCreateur(demande.id_voyage, index)}><CheckIcon aria-hidden="true"/></ButtonCircleSmall> <ButtonCircleSmall onClick={() => handleRefuserCoCreateur(demande.id_voyage, index)} className="couleurRouge"><XMarkIcon/></ButtonCircleSmall></div>
                    ))
                  ) : null }
                </div>
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
    );
  };

  const renderSectionInfos= () => {
    return (
      <div className="listingSection__wrap [ nc-box-has-hover ] [ nc-dark-box-bg-has-hover ]">
        <div>
          <h2 className="text-xl font-semibold dark:text-white">{t('informations')}</h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <Tab.Group>
            <Tab.Panels>
              <Tab.Panel className="">
                <div className="mt-1">
                   {//  <div className="mb-1 text-xs sm:text-sm "><span className="couleurRose text-sm texteGras">ASTUCE <i className="las la-lightbulb"></i></span> Ajoutez un raccourci sur la page d'accueil de votre smartphone pour lancer tripkygo comme une application mobile : <a href='https://www.clubic.com/tutoriels/article-889913-1-comment-ajouter-raccourci-web-page-accueil-iphone.html' rel="noreferrer" target="_blank"><u>tutoriel pour iPhone</u></a> ou <a href='https://www.clubic.com/tutoriels/article-891621-1-comment-ajouter-raccourci-web-page-accueil-smartphone-android.html' rel="noreferrer" target="_blank"><u>tutoriel pour Android</u></a>.</div>
                    }
                <div className="mb-1 text-xs sm:text-sm dark:text-white"><span className="couleurRose text-sm texteGras">{t('planner.newLabel')} </span>{t('planner.v3Announcement')}</div>
                </div>
              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
    );
  };

  const renderSectionSondage= () => {
    return (
      <div className="listingSection__wrap [ nc-box-has-hover ] [ nc-dark-box-bg-has-hover ]">
        <div>
          <h2 className="text-xl font-semibold"><span className="couleurRose text-lg texteGras"><i className="las la-exclamation-circle"></i> {t('planner.surveyTitle')}</span></h2>
        </div>
        <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <Tab.Group>
            <Tab.Panels>
              <Tab.Panel className="">
                <div className="mt-1">
                     <div className="mb-1 text-xs sm:text-sm lg:text-lg "><b>{t('planner.surveySubscription')}</b><br/>
                     <i className=" text-sondage ">{t('planner.examples')}
                      <ul>
                      <li>- {t('planner.premiumMobile')}</li><li>- {t('planner.premiumPhotos')}</li><li>- {t('planner.premiumGroupCosts')}</li><li>- {t('planner.premiumCurrencies')}</li><li>- {t('planner.premiumRoadRoute')}</li><li>- {t('planner.premiumBookLayout')}</li><li>etc...</li>
                        </ul>
                        </i></div>
                     <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                       <div className="flex items-center mt-2">
        <input
          checked={valeurReponse1}
          id={"reponse1"}
          name={"reponse1"}
          type="radio"
          onChange={() => handleRadioChange("reponse1")}
          className="focus:ring-primary-500 h-6 w-6 text-primary-500 border-neutral-300 !checked:bg-primary-500 bg-transparent"
        />
        <label
          htmlFor={"test"}
          className="ml-3 block text-xs sm:text-sm lg:text-lg  font-medium text-neutral-700 dark:text-neutral-300"
        >
          {t('planner.yes')}
        </label>
        </div>
        <div className="flex items-center mt-2">
        <input
          checked={valeurReponse2}
          id={"reponse2"}
          name={"reponse2"}
          type="radio"
          onChange={() => handleRadioChange("reponse2")}
          className="focus:ring-primary-500 h-6 w-6 text-primary-500 border-neutral-300 !checked:bg-primary-500 bg-transparent"
        />
        <label
          htmlFor={"reponse2"}
          className="ml-3 block text-xs sm:text-sm lg:text-lg  font-medium text-neutral-700 dark:text-neutral-300"
        >
          {t('planner.no')}
        </label>
        </div>
      </div>
                </div>
                { affichagePrix && (
                  <>
                                  <div className="mt-4">
                                  <div className="mb-1 text-xs sm:text-sm lg:text-lg "><b>{t('planner.surveyPrice')}</b></div>
                                  <i className=" text-sondage ">{t('planner.surveyPriceHint')}</i>
                                  <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                                    <div className="flex items-center mt-2">
                     <input
                       checked={valeurPrix0}
                       id={"prix0"}
                       name={"prix0"}
                       type="radio"
                       onChange={() => handleRadioChange("prix0")}
                       className="focus:ring-primary-500 h-6 w-6 text-primary-500 border-neutral-300 !checked:bg-primary-500 bg-transparent"
                     />
                     <label
                       htmlFor={"prix0"}
                       className="ml-3 block text-xs sm:text-sm lg:text-lg  font-medium text-neutral-700 dark:text-neutral-300"
                     >
                       {`2€${t('planner.perMonth')}`}
                     </label>
                     </div>
                     <div className="flex items-center mt-2">
                     <input
                       checked={valeurPrix1}
                       id={"prix1"}
                       name={"prix1"}
                       type="radio"
                       onChange={() => handleRadioChange("prix1")}
                       className="focus:ring-primary-500 h-6 w-6 text-primary-500 border-neutral-300 !checked:bg-primary-500 bg-transparent"
                     />
                     <label
                       htmlFor={"prix1"}
                       className="ml-3 block text-xs sm:text-sm lg:text-lg  font-medium text-neutral-700 dark:text-neutral-300"
                     >
                       {`3€${t('planner.perMonth')}`}
                     </label>
                     </div>
                     <div className="flex items-center mt-2">
                     <input
                       checked={valeurPrix2}
                       id={"prix2"}
                       name={"prix2"}
                       type="radio"
                       onChange={() => handleRadioChange("prix2")}
                       className="focus:ring-primary-500 h-6 w-6 text-primary-500 border-neutral-300 !checked:bg-primary-500 bg-transparent"
                     />
                     <label
                       htmlFor={"prix2"}
                       className="ml-3 block text-xs sm:text-sm lg:text-lg  font-medium text-neutral-700 dark:text-neutral-300"
                     >
                       {`4€${t('planner.perMonth')}`}
                     </label>
                     </div>
                     <div className="flex items-center mt-2">
                     <input
                       checked={valeurPrix3}
                       id={"prix3"}
                       name={"prix3"}
                       type="radio"
                       onChange={() => handleRadioChange("prix3")}
                       className="focus:ring-primary-500 h-6 w-6 text-primary-500 border-neutral-300 !checked:bg-primary-500 bg-transparent"
                     />
                     <label
                       htmlFor={"prix3"}
                       className="ml-3 block text-xs sm:text-sm lg:text-lg  font-medium text-neutral-700 dark:text-neutral-300"
                     >
                       {`5€${t('planner.perMonth')}`}
                     </label>
                     </div>
                     <div className="flex items-center mt-2">
                     <input
                       checked={valeurPrix4}
                       id={"prix4"}
                       name={"prix4"}
                       type="radio"
                       onChange={() => handleRadioChange("prix4")}
                       className="focus:ring-primary-500 h-6 w-6 text-primary-500 border-neutral-300 !checked:bg-primary-500 bg-transparent"
                     />
                     <label
                       htmlFor={"prix4"}
                       className="ml-3 block text-xs sm:text-sm lg:text-lg  font-medium text-neutral-700 dark:text-neutral-300"
                     >
                       {`6€${t('planner.perMonth')}`}
                     </label>
                     </div>
                     <div className="flex items-center mt-2">
                     <input
                       checked={valeurPrix5}
                       id={"prix5"}
                       name={"prix5"}
                       type="radio"
                       onChange={() => handleRadioChange("prix5")}
                       className="focus:ring-primary-500 h-6 w-6 text-primary-500 border-neutral-300 !checked:bg-primary-500 bg-transparent"
                     />
                     <label
                       htmlFor={"prix5"}
                       className="ml-3 block text-xs sm:text-sm lg:text-lg  font-medium text-neutral-700 dark:text-neutral-300"
                     >
                       {`${t('planner.moreThan')} 6€${t('planner.perMonth')}`}
                     </label>
                     </div>
                     </div>
                     </div>
</>
                )}
                { affichageValider && (
                <div className="mt-4">
                <div className="pt-0 mt-4">
                              <ButtonPrimary 
                              onClick={handleSubmit} 
                       >
                                {t('planner.sendAnswer')}
                              </ButtonPrimary>
                            </div>
                               </div>
                )}

              </Tab.Panel>
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
    );
  };

  return (
    <div className={`nc-MesVoyages ${className}`} data-nc-id="MesVoyages">
      <Helmet>
        <title>{t('mesVoyages')}</title>
      </Helmet>
      <main className="container mt-4 md:mt-8 mb-24 lg:mb-32 flex flex-col lg:flex-row">
        <div className="w-full space-y-8 lg:space-y-10 lg:pl-10 flex-shrink-0">
          {/* Annonce Booking.com */}
          {/*!(isAfterNov20 && isBeforeDec5) && (
          <div className=" justify-center mb-4 md:mb-0 hidden md:flex">
            <ins className="bookingaff" data-aid="2423292" data-target_aid="2423292" data-prod="banner" data-width="728" data-height="90" data-lang="fr">
              <iframe 
                src="//www.booking.com/flexiproduct.html?product=banner&amp;w=728&amp;h=90&amp;lang=fr&amp;aid=2423292&amp;target_aid=2423292&amp;tmpl=affiliate_banner&amp;fid=1719069401328&amp;" 
                width="728" 
                height="90" 
                scrolling="no" 
                style={{ order: "none", padding: 0, margin: 0, overflow: "hidden", width: "728px", height: "90px" }}
                marginHeight={0} 
                marginWidth={0} 
                frameBorder={0} 
                allowTransparency={true} 
                id="booking_widget__2423292__1719069401328" 
                data-responsive={false}
              ></iframe>
            </ins>
          </div>
          )}
          {isAfterNov20 && isBeforeDec5 && (
            <>
          <div className=" justify-center mb-4 md:mb-0 hidden md:flex">
            <a href="https://www.booking.com/dealspage.html?campaign_id=black_friday&label=sp_black_friday"
            target="_blank" rel="noreferrer" >
              <img width="550" src={`https://wasabi.bstatic.com/banners/sp_deals/${langue}/wide_rectangle_v1.png`} alt="Booking.com Offres Black Friday"/>
            </a>
          </div>
          <div className=" justify-center mb-4 md:mb-0 flex md:hidden">
            <a href="https://www.booking.com/dealspage.html?campaign_id=black_friday&label=sp_black_friday"
            target="_blank" rel="noreferrer" >
              <img src={`https://wasabi.bstatic.com/banners/sp_deals/${langue}/mobile_v2.png`} alt="Booking.com Offres Black Friday"/>
            </a>
          </div>
          </>
          )*/}
          <div className="text-center mb-4 md:mb-0 hidden lg:block">
            {/* Bouton Nouveau voyage */}
            <ButtonPrimary
              sizeClass="px-6 py-3 lg:px-8 lg:py-4 rounded-xl"
              fontSize="text-sm sm:text-base lg:text-lg font-medium"
              onClick={() => navigate("/")}
            >
              {t('nouveauVoyage')}
            </ButtonPrimary>
          </div> 
          { voyageurData && voyageurData.mailKo && voyageurData.mailKo === 'X' && (
            <div className="texteGras items-center text-center space-x-5 mb-6 text-xs md:text-sm lg:text-sm xl:text-sm ">
              <p><i className='las la la-warning'></i>{t('messageEmailInvalide1')}<a href={t('lienCompte')}><u>{t('compteMin')}</u></a>{t('messageEmailInvalide2')}<a href={t('lienContact')}><u>{t('messageEmailInvalide3')}</u></a>{t('messageEmailInvalide4')}</p>
            </div>
          )}
          
           {voyageurData && !voyageurData.idSondage && (
            renderSectionInfos()
           )}
           {voyageurData && voyageurData.idSondage && affichageSondage && (
            renderSectionSondage()
           )}
           {voyageurData && voyageurData.mesDemandes && voyageurData.mesDemandes.length > 0 && (
           renderSectionCoCreateur()
           )}
          {renderSection1()}
        </div>
      </main>
      {isLoading && (
  <Transition appear show={true} as={Fragment}>
    <Dialog
      as="div"
      className="fixed inset-0 z-[100] overflow-y-auto" // Plus élevé pour l'attente
      onClose={() => {}} // Pas de fermeture pour la modale d'attente
    >
      <div className="min-h-screen flex items-center justify-center px-4 text-center">
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 bg-black bg-opacity-60" />
        </Transition.Child>
        
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0 scale-95"
          enterTo="opacity-100 scale-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0 scale-95"
        >
          <div
            className="inline-block transition-all transform rounded-2xl bg-white dark:bg-neutral-900 dark:border dark:border-neutral-700 dark:text-neutral-100 shadow-xl px-8 py-4"
          >
            <h3 className="text-lg font-medium leading-6 text-gray-900 dark:text-neutral-200">
              Traitement en cours, veuillez patienter...
            </h3>
          </div>
          
        </Transition.Child>
      </div>
    </Dialog>
  </Transition>
  
)}
    </div>
  );
};

export default MesVoyages;
